export { default } from '@/validation/rules/common/checkAge';
